export const SET_WORK_SESSION = "SET_WORK_SESSION";
export const SET_WORK_SESSION_CURRENT = "SET_WORK_SESSION_CURRENT";
export const CLEAR_WORK_SESSION = "CLEAR_WORK_SESSION";
